/**
 * Contract addresses for Ostium on Arbitrum
 */

import { type Address } from 'viem';

export const ARBITRUM_MAINNET = {
  chainId: 42161,
  contracts: {
    usdc: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831' as Address,
    trading: '0x6D0bA1f9996DBD8885827e1b2e8f6593e7702411' as Address,
    tradingStorage: '0xcCd5891083A8acD2074690F65d3024E7D13d66E7' as Address,
    tradingCallbacks: '0x7720fC8c8680bF4a1Af99d44c6c265a74e9742a9' as Address,
  },
};

export const ARBITRUM_TESTNET = {
  chainId: 421614,
  contracts: {
    usdc: '0xe73B11Fb1e3eeEe8AF2a23079A4410Fe1B370548' as Address,
    trading: '0x2A9B9c988393f46a2537B0ff11E98c2C15a95afe' as Address,
    tradingStorage: '0x0b9F5243B29938668c9Cfbd7557A389EC7Ef88b8' as Address,
    tradingCallbacks: '0x83DC7c5dDeAD58f47230b70e6EF6bc44064BD814' as Address,
  },
};

export function getNetworkConfig(isTestnet: boolean = false) {
  return isTestnet ? ARBITRUM_TESTNET : ARBITRUM_MAINNET;
}
